<div *ngIf="open" class="fixed inset-0 z-[80] flex items-end justify-center md:items-center md:p-4" (keydown.escape)="dismiss()">
  <div class="absolute inset-0 bg-black/35" (click)="dismiss()"></div>

  <div
    role="dialog"
    aria-modal="true"
    class="relative flex max-h-[650px] w-full flex-col overflow-y-auto rounded-t-[20px] px-6 pb-[max(24px,env(safe-area-inset-bottom))] pt-10 text-black shadow-[0px_1px_31px_0px_rgba(200,178,189,0.6)] md:max-h-[90dvh] md:w-[755px] md:rounded-[20px] md:p-14 md:shadow-[0px_1px_16px_rgba(0,0,0,0.25)]"
    style="background-image: linear-gradient(180deg, #ECEAFF 0.86%, #FFFFFF 105.42%)"
  >
    <ng-content></ng-content>
  </div>
</div>
